import { useTranslation } from "react-i18next";
import { Separator } from "@/components/ui/separator";
import { DocumentListItem } from "@/components/shared/documentListItem";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { FileTypeEnum } from "@/constants/enums/fileType.enum";

const ORDERED_DOCUMENT_GROUPS: FileTypeEnum[][] = [
  [
    FileTypeEnum.EXPEDITION_QUOTE,
    FileTypeEnum.EXPEDITION_QUOTE_EXCEL,
    FileTypeEnum.EXPEDITION_INVOICE,
    FileTypeEnum.EXPEDITION_FORM,
    FileTypeEnum.EXPEDITION_FORM_EXCEL,
    FileTypeEnum.EXPEDITION_CUSTOM_INVOICE,
    FileTypeEnum.EXPEDITION_CUSTOM_INVOICE_EXCEL,
    FileTypeEnum.EXPEDITION_COMPLEMENTARY_INVOICE,
  ],
  [
    FileTypeEnum.EXPEDITION_DAE,
    FileTypeEnum.EXPEDITION_IMPORT_LICENSE,
    FileTypeEnum.IMPORTER_LICENCE,
    FileTypeEnum.IMPORTER_BASIC_PERMIT,
    FileTypeEnum.EXPEDITION_CERTIFICATE_CHAMPAGNE,
  ],
];

type ExpeditionDocument = NonNullable<
  NonNullable<GetOneExpeditionBoResponseDto["expeditionDocuments"]>["documents"]
>[number];

const groupDocuments = (documents: ExpeditionDocument[]) => {
  const orderedTypes = ORDERED_DOCUMENT_GROUPS.flat();
  const groups = ORDERED_DOCUMENT_GROUPS.map((types) =>
    documents
      .filter((document) => types.includes(document.type as FileTypeEnum))
      .sort(
        (a, b) => types.indexOf(a.type as FileTypeEnum) - types.indexOf(b.type as FileTypeEnum),
      ),
  );
  const others = documents.filter(
    (document) => !orderedTypes.includes(document.type as FileTypeEnum),
  );
  return [...groups, others].filter((group) => group.length > 0);
};

export const SideContentDocuments = ({
  expedition,
}: {
  expedition: GetOneExpeditionBoResponseDto;
}) => {
  const { t } = useTranslation("boExpeditionForm");
  const groups = groupDocuments(expedition.expeditionDocuments?.documents ?? []);

  return (
    <div className="flex w-full flex-col gap-2">
      <p className="text-sm text-gray-500">{t("sidePanelDocuments.title")}</p>
      {groups.map((group, groupIndex) => (
        <div key={"group-" + groupIndex.toString()} className="flex flex-col">
          {groupIndex > 0 && <div className="mt-1 mb-3 border-t-2 border-dashed border-gray-300" />}
          {group.map((document, index) => (
            <div key={document.id}>
              <DocumentListItem file={document} />
              {index < group.length - 1 && <Separator />}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
